import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { SessionDataService } from '../session-data/session-data.service';
import { SessionData } from '../../domain/session-data';
import { switchMap } from 'rxjs/operators';
import { URL_LOGIN } from 'src/app/shared/config-urls';


@Injectable()
export class LoginService {
  httpArg: {};

  constructor(private httpService: HttpService, private sessionService: SessionDataService) { }

  doLogin(password: string) {
    return this.sessionService.getSessionData()
      .pipe(switchMap(sessionData =>
        this.httpService.post<any>(
          `${URL_LOGIN}`, this.getLoginBody(sessionData, password), sessionData.agreementMap)));
  }

  getLoginBody(sessionData: SessionData, password: string): {} {
    return this.httpArg = {
      'loginRequest': {
        'username': sessionData.username,
        'password': password,
        'userLanguage': sessionData.selectedLanguage,
        'channel': sessionData.channel,
        'P2hoCyPjpg': sessionData.P2hoCyPjpg,
        'fToken': sessionData.fToken,
        'deviceId': this.sessionService.getDeviceId()
      }
    };
  }
}
